import React, { useState, useCallback, useRef } from "react";
import { StaffFrame, AgentView, Toast } from "./DashboardShared";

export default function AgentPage() {
  const [toast, setToast] = useState(null);
  const toastTimer = useRef(null);
  const showToast = useCallback((msg, type = "error") => {
    if (toastTimer.current) clearTimeout(toastTimer.current);
    setToast({ msg, type });
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  }, []);

  return (
    <StaffFrame>
      <Toast toast={toast} />
      <div className="topbar">
        <div>
          <div className="topbar-title">Émission de billets</div>
          <div className="topbar-sub">Recherchez un trajet et émettez un billet pour un passager</div>
        </div>
      </div>
      <AgentView activePage="search" showToast={showToast} />
    </StaffFrame>
  );
}
